import GoogleSsoButton from '../../google-sso-button/google-sso-button';
import LoginHomeComponent from './login-home-component';

/***
 * The login home page, containing the Google SSO login button.
 */
const loginHome = angular
    .module('FacilityData.Home.LoginHome', [
        GoogleSsoButton
    ])
    .component('loginHome', LoginHomeComponent)
    .name;

export default loginHome;


// WEBPACK FOOTER //
// ./app/components/home/login-home/login-home.js